module.exports = __webpack_public_path__ + "img/emoji-heart-eyes-fill.b81a9d1f.svg";